import { render, staticRenderFns } from "./Dialog.vue?vue&type=template&id=28828de7&"
import script from "./Dialog.vue?vue&type=script&lang=js&"
export * from "./Dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/madamesumcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28828de7')) {
      api.createRecord('28828de7', component.options)
    } else {
      api.reload('28828de7', component.options)
    }
    module.hot.accept("./Dialog.vue?vue&type=template&id=28828de7&", function () {
      api.rerender('28828de7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/madamesum/js/components/Dialog.vue"
export default component.exports